import { createContext } from 'react';

const OAuthContext = createContext(null);

export default OAuthContext;
